module.exports = __webpack_public_path__ + "static/media/image19.ea480098.png";